import { jsx as r } from "@emotion/react/jsx-runtime";
import { TextInput as a, FontAwesomeIconsPartooUsed as i, LeftElementType as l } from "@partoohub/ui";
import { useBusinessModalContext as c } from "../../../../../BusinessModalContext.js";
import { setSearchBusiness as m } from "../../../../../reducer/businessModal.actions.js";
const d = () => {
  const {
    dispatch: s,
    preFilters: t,
    translations: n
  } = c(), e = (o) => {
    s(m(o));
  };
  return /* @__PURE__ */ r(a, { label: n.search, onReset: () => e(""), isReset: !0, value: t?.searchBusiness ?? "", onChange: e, dataTrackId: "business_modal__query_search__textfield", leftElementType: l.Icon, leftElement: [i.faSearch] });
};
export {
  d as BusinessSearch
};
